import React from "react";

// reactstrap components
import {
    Table,
    Button,
    DropdownMenu,
    DropdownItem,
    Modal,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import DeductDataService from "../../services/DeductDataService";

class CheckoutHistories extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            itemToDisabled: {},
        }
        this.DeductDataService = new DeductDataService();
    }

    toggleModal = (user) => {
        this.props.toggleModal("formModal", "edit", user)
    }

    toggleModals = (state, item) => {
        this.setState({
          [state]: !this.state[state],
          itemToDisabled: item,
        });
    };

    handleResponse(data, successMessage) {
        if (data.data?.errorMessage !== undefined) {
            this.props.setErrorMessage(data.data.errorMessage);
            this.toggleModals("notificationModal")
            this.setState({ itemToDisabled: {} })
        } else if (data.header?.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
              return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("notificationModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ itemToDisabled: {} })
            this.props.fetchData()
        }
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                <tr>
                    <th scope="col">Checkout ID</th>
                    <th scope="col">Subtotal</th>
                    <th scope="col">NIK pembeli</th>
                    <th scope="col">Tanggal checkout</th>
                    <th scope="col" />
                </tr>
                </thead>
                <tbody>
                {this.props.items.map((item) => (
                    <tr>
                    <th style={{cursor: 'pointer'}} onClick={() => this.toggleModal(item)} scope="row">
                        {item.order_id}
                    </th>
                    <td style={{cursor: 'pointer'}} onClick={() => this.toggleModal(item)}>
                        <NumberFormat value={item.total} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} suffix={',00'} />
                    </td>
                    <td style={{cursor: 'pointer'}} onClick={() => this.toggleModal(item)}>
                        {item.nik !== 0 ? item.nik : '-'}
                    </td>
                    <td style={{cursor: 'pointer'}} onClick={() => this.toggleModal(item)}>
                        {new Date(item.created_at).toLocaleDateString() + ' ' + new Date(item.created_at).toLocaleTimeString()}
                    </td>
                    <td className="text-right">
                        <UncontrolledDropdown>
                        <DropdownToggle
                            className="btn-icon-only text-light"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                        >
                            <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem
                            onClick={() => this.toggleModal(item)}
                            >
                            Lihat detil
                            </DropdownItem>
                        </DropdownMenu>
                        <Modal
                            className="modal-dialog-centered modal-danger"
                            contentClassName="bg-gradient-danger"
                            isOpen={this.state.notificationModal}
                            toggle={() => this.toggleModals("notificationModal")}
                        >
                            <div className="modal-header">
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => this.toggleModals("notificationModal")}
                                >
                                    <span aria-hidden={true}>×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="py-3 text-center">
                                    <i className="ni ni-bell-55 ni-3x" />
                                    <h4 className="heading mt-4">Anda akan mengnonaktifkan transaksi berikut</h4>
                                    <p>
                                        Checkout id <b>{this.state.itemToDisabled?.order_id}</b> <br/>
                                        NIK Pembeli <b>{this.state.itemToDisabled?.nik !== 0 ? this.state.itemToDisabled?.nik : '-'}</b>
                                    </p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <Button
                                    className="text-white ml-auto"
                                    color="link"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => this.toggleModal("notificationModal")}
                                >
                                    Batal
                    </Button>
                                <Button
                                    className="btn-white"
                                    color="default"
                                    type="button"
                                    onClick={() => this.handleDisableItem()}
                                >
                                    Nonaktifkan
                    </Button>
                            </div>
                        </Modal>
                        </UncontrolledDropdown>
                    </td>
                    </tr>
                ))}
                </tbody>
            </Table>

        )
    };
}

export default CheckoutHistories;
